import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@cian/ui-kit';
import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';

import { openCallbackPopup } from '../../actions';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { getContacts, getDeveloper } from '../../selectors';
import { trackCallbackPopupOpen } from '../../services';
import { TCallbackPlace } from '../../types/callback';
import { TSPTheme } from '../../types/specialProjects/themes';
import { phoneToString } from '../../utils';

interface ICallbackProps {
  customTheme?: TSPTheme;
  fullWidth?: boolean;
  buttonText?: string;
  place: TCallbackPlace;
  size?: TButtonSize;
  theme?: TButtonTheme;
}

export function CallbackButtonContainer({
  buttonText = 'Перезвоните мне',
  customTheme,
  fullWidth,
  place,
  size = 'M',
  theme = 'fill_white_primary',
}: ICallbackProps) {
  const contacts = useSelector(getContacts);
  const developer = useSelector(getDeveloper);
  const dispatch = useDispatch();

  const preparedPhone = React.useMemo(() => phoneToString(contacts.phone), [contacts.phone]);

  const handlePopupOpen = React.useCallback(() => {
    dispatch(openCallbackPopup(place));
    trackCallbackPopupOpen({ developer, place });
  }, [dispatch, developer, place]);

  if (!preparedPhone) {
    return null;
  }

  return (
    <SPThemeWrapper theme={customTheme}>
      <Button theme={theme} size={size} fullWidth={fullWidth} onClick={handlePopupOpen}>
        {buttonText}
      </Button>
    </SPThemeWrapper>
  );
}
